import { Component, ViewEncapsulation, HostBinding, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { User } from '../../../shared/models/user';
import { UserService } from '../../../shared/services/user.service';
import { pageTransitions } from '../../../shared/animations/page-transitions';
import { LocationService } from '../../../shared/services/location.service';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';

import { AuctionOverviewComponent } from './overview/auction-overview.component';

@Component({
	selector: 'copo-auction-dashboard',
	templateUrl: './auction-dashboard.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [PageHeaderComponent, AuctionOverviewComponent, TranslateModule]
})
export class AuctionDashboardComponent implements OnInit {
	@HostBinding('class.passthrough') readonly passthrough = true;
	user: User;
	isLoading = true;

	constructor(
		private readonly userService: UserService,
		private readonly locationService: LocationService
	) {
		this.user = this.userService.user;
	}

	ngOnInit() {
		this.isLoading = false;
	}

	goBack() {
		this.locationService.back();
	}
}
